export default "__VITE_ASSET__DSJXtVFM__"